import React from 'react'
import {
    Wrapper,
    ShortlistBox,
    Title,
    Description,
    Section,
    Heading,
    Text,
    TagContainer,
    Tag,
    RejectBox,
} from './style'
import { getDisplayCriterionText } from './criterionText'

const AIProfileSummaryTab = ({ aiMatch }) => {
  if (!aiMatch) return null

  const isRecommended = (aiMatch.overall_score || 0) >= 2.5

  return (
    <Wrapper>
      {/* Why to Shortlist / Reject */}
      {isRecommended ? (
        <ShortlistBox>
          <Title>Why to Shortlist?</Title>
          <Description>{aiMatch.match_summary || 'No summary available'}</Description>
        </ShortlistBox>
      ) : (
        <RejectBox>
          <Title>Why to Reject?</Title>
          <Description>{aiMatch.match_summary || 'No summary available'}</Description>
        </RejectBox>
      )}

      {/* Key Gap */}
      {aiMatch.gaps?.length > 0 && (
        <Section>
          <Heading>Key Gap</Heading>
          <Text>{aiMatch.gaps.join('. ')}</Text>
        </Section>
      )}

      {/* Strengths */}
      {aiMatch.strengths?.length > 0 && (
        <Section>
          <Heading>Strengths</Heading>
          <TagContainer>
            {aiMatch.strengths.map((item, index) => (
              <Tag key={index}>{item}</Tag>
            ))}
          </TagContainer>
        </Section>
      )}

      {/* Risk Signals — criteria not met */}
      {aiMatch.criteria_scores?.filter(c => !c.met)?.length > 0 && (
        <Section>
          <Heading>Risk Signals</Heading>
          <TagContainer>
            {aiMatch.criteria_scores.filter(c => !c.met).map((item, index) => (
              <Tag key={index}>{getDisplayCriterionText(item.text)}</Tag>
            ))}
          </TagContainer>
        </Section>
      )}
    </Wrapper>
  )
}

export default AIProfileSummaryTab
